/**
 * @generated SignedSource<<1a0b4e0663873c01bbbb9dd7bd01b8d7>>
 * @relayHash 30691b3967dbd9d64acb068f76743905
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ef6d791b0242189eea2bcde886ec09d59b628a5711acd785688264133aa4257b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentOverviewInternalsQuery$variables = {
  helpCenterAri: string;
  isVersioningEnabled: boolean;
};
export type AgentOverviewInternalsQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianCsmAgentOverview">;
    } | null | undefined;
    readonly agents?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"multiVersionAgentSummary_AtlassianCsmAgentOverview">;
    }> | null | undefined;
  } | null | undefined;
};
export type AgentOverviewInternalsQuery = {
  response: AgentOverviewInternalsQuery$data;
  variables: AgentOverviewInternalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isVersioningEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "agentCard_AtlassianCsmAgentOverview"
                  }
                ]
              },
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "multiVersionAgentSummary_AtlassianCsmAgentOverview"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              (v3/*: any*/),
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isCsmAiMultiVersionAgentResult"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "agentId"
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 2
                              }
                            ],
                            "concreteType": "CsmAiAgentVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CsmAiAgentVersion",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "versionNumber"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "versionType"
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "agentIdentityConfig",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v4/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "type": "CsmAiAgentIdentity"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "message"
                                          }
                                        ],
                                        "type": "QueryError"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "versions(first:2)"
                          }
                        ],
                        "type": "CsmAiMultiVersionAgent"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ef6d791b0242189eea2bcde886ec09d59b628a5711acd785688264133aa4257b",
    "metadata": {},
    "name": "AgentOverviewInternalsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a59febd68f39ba200fdd13d1f796b087";

export default node;
